export default __webpack_public_path__ + "static/media/abi_logo_black.63c7ba46.png";